import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../models/User';
import { Establishment } from '../models/Establishment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  userSource: BehaviorSubject<any> = new BehaviorSubject<User | null>(null);

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.setUser(this.user);
  }

  setUser(value: User | null) {
    this.userSource.next(value);
  }

  getUser(): Observable<User> {
    return this.userSource.asObservable();
  }

  get token(): string {
    try {
      return localStorage.getItem('authToken') || '';
    } catch (error) {
      return '';
    }
  }

  get user(): User | null {
    try {
      return JSON.parse(localStorage.getItem('user')!);
    } catch {
      return null;
    }
  }

  /** Compte pro créé par le pro lui-même et pas encore validé : il peut se connecter mais ne peut pas postuler. */
  get isPendingValidation(): boolean {
    const u = this.user;
    return !!u && u.kind === 'CANDIDAT' && u.status === 'PENDING';
  }

  /**
   * Relit le statut du compte (/users/me) : l'équipe a pu valider le compte depuis la dernière connexion.
   * Le champ `status` est omis par le back pour un compte actif : on le retire alors de la session locale.
   */
  refreshAccountStatus(): Observable<any> {
    return new Observable((observer) => {
      const current: any = this.user;
      if (!current || !this.token) {
        observer.next(null);
        observer.complete();
        return;
      }
      this.http.get<any>(`${environment.api.BASE_URL_NOTIF}/users/me`).subscribe({
        next: (fresh) => {
          if (fresh && fresh.id) {
            const merged: any = { ...current };
            if (fresh.status) {
              merged.status = fresh.status;
              merged.status_label = fresh.status_label;
            } else {
              delete merged.status;
              delete merged.status_label;
            }
            localStorage.setItem('user', JSON.stringify(merged));
            this.setUser(merged);
          }
          observer.next(fresh);
          observer.complete();
        },
        error: (err) => observer.error(err),
      });
    });
  }

  get establishment(): Establishment | null {
    try {
      return JSON.parse(localStorage.getItem('establishment')!);
    } catch {
      return null;
    }
  }

  get id(): number | null {
    try {
      return Number(localStorage.getItem('id'));
    } catch (error) {
      return null;
    }
  }

  notif() {
    return this.http.get(`${environment.api.BASE_URL_NOTIF}/notifications`);
  }

  readNotif(id: number, body: any) {
    return this.http.put(
      `${environment.api.BASE_URL_NOTIF}/notifications/${id}/read`,
      body
    );
  }

  login(body: any): Observable<any> {
    return this.http.post(`${environment.api.AUTH_URL}/sign_in`, body);
  }

  fogetPassword(body: any): Observable<any> {
    return this.http.post(`${environment.api.AUTH_URL}/password/forgot`, body);
  }

  signup(body: any): Observable<any> {
    return this.http.post(`${environment.api.AUTH_URL}/sign_up`, body);
  }

  activate(email: string, code: string): Observable<any> {
    return this.http.get(`${environment.api.AUTH_URL}/check_verification_code?email=${email}&code=${code}`);
  }

  disconnect() {
    let privacyPreferences = localStorage.getItem("privacy_preferences")
    localStorage.clear();
    this.setUser(null);
    //this.cookie.deleteAll()
    //this.cookie.delete('token');
    //this.cookie.delete('authToken');
    if (!!privacyPreferences) localStorage.setItem('privacy_preferences', privacyPreferences)
    this.router.navigate(['/login']);
    location.reload()
  }

  softDisconnect() {
    let privacyPreferences = localStorage.getItem("privacy_preferences")
    localStorage.clear();
    this.setUser(null);
    if (!!privacyPreferences) localStorage.setItem('privacy_preferences', privacyPreferences)
  }
}
